import LoginForm from "../components/LoginForm/LoginForm";

export default function Login(){
    return(
        <LoginForm/>
    )

}